var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0009,
    cy: 12,
    r: 12,
    fill: "#907c4b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0355 6.73486L12.8405 14.3099H11.1905L10.9655 6.73486H13.0355ZM13.0805 16.2299C13.0805 16.5099 12.9755 16.7549 12.7655 16.9649C12.5555 17.1649 12.3055 17.2649 12.0155 17.2649C11.7155 17.2649 11.4555 17.1649 11.2355 16.9649C11.0255 16.7549 10.9205 16.5099 10.9205 16.2299C10.9205 15.9299 11.0255 15.6749 11.2355 15.4649C11.4555 15.2449 11.7155 15.1349 12.0155 15.1349C12.3055 15.1349 12.5555 15.2449 12.7655 15.4649C12.9755 15.6749 13.0805 15.9299 13.0805 16.2299Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.c495d43d050c9eb02a059e53fc69980a.svg";
export { ForwardRef as ReactComponent };